import React, { createContext, useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth'; // v9 modular

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    console.log("Setting up auth state listener");
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        console.log("sending logged in msg");
        
        setUser(user);
        let { uid, displayName, email, photoURL } = user;

        // OPTIONAL: get token if you need it. Be careful with sending tokens.
        // const token = await user.getIdToken();
        window.postMessage({ type: 'LOGIN_SUCCESS', user: { uid, displayName, email, photoURL } }, '*');
      } else {
                window.postMessage({ type: 'LOGOUT'}, '*');

        setUser(null);
      }
    });


    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ user }}>
      {children}
    </AuthContext.Provider>
  );
}
